/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { alias } from '@ember/object/computed';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';

import MessageLimitModel from 'cio/models/message-limit';
import MessageSettingsService from 'cio/services/message-settings';

interface CioDeliveriesListRetryModalArgs {
  messageCount?: number;
  itemLabel?: string;
  title?: string;
  onClose: () => unknown;
  onConfirm: (overrideLimit?: boolean) => unknown;
  hasReadOnlyPermission: boolean;
}

export default class CioDeliveriesListRetryModal extends Component<CioDeliveriesListRetryModalArgs> {
  @service messageSettings!: MessageSettingsService;

  @tracked overrideLimit = true;

  @alias('messageSettings.messageLimit') messageLimit!: MessageLimitModel;

  get title() {
    return this.args.title ?? 'Retrying may go over message limits';
  }

  get messageCountForActionButtonPluralize() {
    return this.args.messageCount ?? 1;
  }

  @action
  confirm(event: Event) {
    event.preventDefault();
    this.args.onConfirm(this.messageSettings.isMessagingLimitEnabled ? this.overrideLimit : undefined);
  }
}
